export const SET_TOKENS = 'SET_TOKENS'
export const FAILED_SET_TOKENS = 'FAILED_SET_TOKENS'
export const SEND_FCM_TOKEN = 'SEND_FCM_TOKEN'
